import { CHANNELS } from "../types/global.enum";
import apiService, { JiraApi } from "./api.service"
import digitalApiService from "./digitalApi.service";
import { getUserName } from "./user.service";

export const loadJiraUsers = async () => {
    const { data } = await JiraApi.get(`/users?username=${getUserName()}`);
    return data?.data;
}

export const loadJiraProjects = async () => {
    const { data } = await JiraApi.get(`/projects?username=${getUserName()}`);
    return data?.data;
}

export const loadJiraStatuses = async () => {
    const { data } = await JiraApi.get(`/issueStatus?username=${getUserName()}`);
    return data?.data;
}

export const createJiraTicket = async (body: any) => {
    const { data } = await JiraApi.post(`/issue`, { ...body });
    return data?.data;
}



export const updateTestResult = async (id: string, jira: string, channel: CHANNELS | null) => {
    const { data } = channel === CHANNELS.DIGITAL ? await digitalApiService.put(`/results/${id}?jiraTicket=${jira}`) : await apiService.put(`/results/${id}?jiraTicket=${jira}`);
    return data?.data;
}


export const updateJiraTicket = async (issueId: string, body: any) => {
    const { data } = await JiraApi.put(`/issue?username=${getUserName()}&issueId=${issueId}`, { ...body });
    return data?.data;
}


export const getJiraStatus = async (issueId: string) => {
    const { data } = await JiraApi.get(`/issue?username=${getUserName()}&issueId=${issueId}`);
    return data?.data;
}